// extracted by mini-css-extract-plugin
module.exports = {"styledInput":"o5iY87w3","buttonWrapper":"yDX0uKhv"};